import { Button, Form, Select, Spin, Typography } from 'antd';
import React, { useCallback, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import settings from '../../settings';
import { searchUsersQuery } from './constants';
import { useManyRemote } from '../../shared/use-many-remote';

const { Text } = Typography;

function SelectUser({ disabled, filters, value, onChange }) {
  const locale = useSelector((store) => store.locale, shallowEqual);
  const {
    error,
    loading,
    data: users,
    search: userSearch,
  } = useManyRemote(
    searchUsersQuery,
    (data) => data.searchUsers,
    settings.querySize,
    filters,
    [{ key: '_score', order: 'DESC' }],
  );
  const handleChange = useCallback(
    (_value, option) => {
      onChange(_value);
    },
    [onChange],
  );
  return (
    <Select
      showSearch
      filterOption={() => true}
      autoComplete="chrome-off"
      allowClear
      disabled={disabled}
      onSearch={(search) => {
        userSearch(search);
      }}
      onChange={handleChange}
      placeholder="Select a user"
      value={value}
    >
      {loading && (
        <Select.Option value="__loading__">
          <Spin spinning={loading} style={{ margin: 8 }} />
        </Select.Option>
      )}
      {!loading && error && (
        <Select.Option value="__error__">
          <Text type="danger">{error.message}</Text>
        </Select.Option>
      )}
      {!loading &&
        users.map((user) => (
          <Select.Option key={user._id} value={user._id} title={user.username}>
            <div className="user-option">
              <div>
                <Text>{`${user.name} (${user.username})`}</Text>
              </div>
            </div>
          </Select.Option>
        ))}
    </Select>
  );
}

export default SelectUser;
